import React, { memo } from 'react'
import { Stack } from '@mui/material'

import Text from '../shared/text/Text'

const FooterLinks = ({ t }) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={4}
      alignItems='center'
      justifyContent='center'
      sx={{ mb: 2, mt: 2 }}
    >
      <Text
        variant='h6'
        label={
          <>
            Copyright &copy; {new Date().getFullYear()}{' '}
            {t('home.copy-right-text')}
          </>
        }
        fontWeight={500}
        color='text.secondary'
      />
    </Stack>
  )
}

export default memo(FooterLinks)
